import { render } from "./DeleteBackup.vue?vue&type=template&id=71dff681&ts=true"
import script from "./DeleteBackup.ts?vue&type=script&lang=ts&external"
export * from "./DeleteBackup.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__